import { Reducer } from "redux";
import type { ReducerAction } from "../../types/common";
import type { Plano } from "../../types/plano";

export const PlanosReducerTypes = {
  SET_LOADING_PLANO: "SET_LOADING_PLANO",
  SET_PLANO: "SET_PLANO",
  SET_PLANOS: "SET_PLANOS",
} as const;

type SetLoadingPlanoAction = ReducerAction<
  typeof PlanosReducerTypes.SET_LOADING_PLANO,
  boolean
>;

type SetPlanoAction = ReducerAction<
  typeof PlanosReducerTypes.SET_PLANO,
  Plano | null
>;

type SetPlanosAction = ReducerAction<
  typeof PlanosReducerTypes.SET_PLANOS,
  Plano[]
>;

export type PlanosReducerActions =
  | SetLoadingPlanoAction
  | SetPlanoAction
  | SetPlanosAction;

type PlanosReducerState = {
  loading: boolean;
  plano?: Plano;
  planos?: Plano[];
};

const InitialState: PlanosReducerState = {
  loading: false,
  plano: undefined,
  planos: undefined,
};

const PlanosReducer: Reducer<PlanosReducerState, PlanosReducerActions> = (
  state = InitialState,
  action
) => {
  switch (action.type) {
    case PlanosReducerTypes.SET_LOADING_PLANO:
      return { ...state, loading: action.payload };
    case PlanosReducerTypes.SET_PLANO:
      return { ...state, plano: action.payload };
    case PlanosReducerTypes.SET_PLANOS:
      return { ...state, planos: action.payload };
    default:
      return state;
  }
};

export default PlanosReducer;
